import { render, staticRenderFns } from "./CompressionMold.vue?vue&type=template&id=4e8b13e1&scoped=true"
import script from "./CompressionMold.vue?vue&type=script&lang=js"
export * from "./CompressionMold.vue?vue&type=script&lang=js"
import style0 from "./CompressionMold.vue?vue&type=style&index=0&id=4e8b13e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8b13e1",
  null
  
)

export default component.exports